<template>
  <el-row class="search">
    <el-row class="search-input" ref="search_input">
      <h1>Encuentra todo lo que necesitas</h1>

      <el-autocomplete
      class="inline-input"
      v-model="main_search"
      :fetch-suggestions="querySearch"
      placeholder="Comida, Restaurants, Outdoor, Joyas, Escapadas, etc"
      :trigger-on-focus="false"
      @select="handleSelect"
      value-key="title"
      >
      <i
      class="el-icon-edit el-input__icon"
      slot="suffix"
      @click="handleIconClick">
      </i>
      <template slot-scope="{ item }">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
              <img :src="item.logo_img_path"/>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">{{ item.title }}</el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">{{ item.short_description }}</el-col>
        </el-row>
      </template>
    </el-autocomplete>
    </el-row>
      <GmapMap
        ref="search_map"
        :center="center"
        :zoom="zoom"
        :options="{ styles: style }"
      >
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center=m.position"
          :icon="{ url: 'static/marker.png'}"
        />
        <GmapCircle
        :bounds="{}"
        :center="m.position"
        :radius="4000"
        :options="{strokeColor: '#FF0000',
              strokeOpacity: 0.2,
              strokeWeight: 1,
              fillColor: '#FF0000',
              fillOpacity: 0.20,}"
        v-for="m in markers"
        @radius_changed="updateCircle('radius', $event)"
        @bounds_changed="updateCircle('bounds', $event)">
        </GmapCircle>

      </GmapMap>
  </el-row>
</template>
<script>

export default {
  name: 'MainMapSearchBlock',
  data() {
    return {
      merchants: [],
      main_search: '',
      center: {lat:-33.457967, lng:-70.653126},
      markers: [],
      zoom: 12,
      style: require("@/assets/styles/default.json")
    };
  },
  methods: {
    querySearch(queryString, cb) {
      var merchants = this.merchants;
      var results = queryString ? merchants.filter(this.createFilter(queryString)) : merchants;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (merchant) => {
        return (_.includes(_.join(merchant.keywords), queryString.toLowerCase()));
      };
    },
    loadAll() {
      let self = this;
      return self.$store.dispatch("listMerchants")
      .then(response => {
        self.merchants = response.data;
        // markers
        _.each(self.merchants, (merchant) => {
          self.markers.push({ position: merchant.coordinates[0] })
        })
      }).catch(error => {
        console.log(error);
      });
    },
    handleSelect(item) { //console.log(item)
      this.center = item.coordinates[0];
      this.zoom = 14;
      this.$refs.search_input.$el.classList.add('close')
      this.$refs.search_map.$el.classList.add('close')
    },
    handleIconClick(ev) {
      // console.log(ev);
    },
  },
  created(){
    this.links = this.loadAll();
  }
};
</script>
<style>
.search-input{
  font-family: 'Montserrat', sans-serif;
  position: absolute;
  z-index: 100;
  /* height: 100vh; */
  opacity: 1;
  width: 100vw;
  margin: 25vh 0;
  transition: all 700ms;

  h1{
    color: white;
    font-size: 4vw;
    transition: all 700ms;
  }

  &.close h1{
    font-size: 0;
    opacity: 0;
  }

  &.close{
    margin: 1vh 0;
    opacity: 0.5;
  }

  .el-autocomplete{
    input{
      color: black;
      min-width: 80vw;
      min-height: 10vw;
      font-size: 5vw;
    }
  }

}

.el-autocomplete-suggestion{
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  li {
    padding: 0 20px;
    margin: 0;
    line-height: 34px;
    cursor: pointer;
    color: black;
    font-size: 1.5vw;
    list-style: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-input__inner{
    color: black
  }
  img{
    max-height: 4vh;
  }
}

/* .vue-map-container{ */
  /* min-width: 80vw; */
  /* margin: auto;
  min-height: 100vh;
  &::before{
    content: '';
    background-color: #E80C7A;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1;
    opacity: 0.4;
    height: 100%;
  }
  &.close::before{
    opacity: 0;
  }
} */

</style>



// WEBPACK FOOTER //
// src/components/merchants/blocks/MainMapSearchBlock.vue